import React from 'react'
import { useTranslation } from 'react-i18next'
import { usePageConfigUser } from 'hooks/usePageConfig'
import { getRelativeTimeString } from 'utils/dateUtil'
import DeletedPost from 'components/visualization/SoundbiteFrame/DeletedPost'

type DeletedProps = {
  deletedSentenceCount: number
  deletedSentenceDateRangeFrom: number
  deletedSentenceDateRangeTo: number
  serialNumber: number
}

const Deleted = ({
  deletedSentenceCount,
  deletedSentenceDateRangeFrom,
  deletedSentenceDateRangeTo,
  serialNumber
}: DeletedProps) => {
  const { t } = useTranslation()
  const userConfig = usePageConfigUser()
  const { timeZone } = userConfig

  if (deletedSentenceCount === 0) {
    return <></>
  }

  const relativeFromDate = getRelativeTimeString(deletedSentenceDateRangeFrom, timeZone)
  const relativeToDate = getRelativeTimeString(deletedSentenceDateRangeTo, timeZone)

  let timestamp = relativeFromDate
  if (relativeFromDate !== relativeToDate) {
    timestamp = `${relativeFromDate} - ${relativeToDate}`
  }

  return (
    <DeletedPost
      content={t('postDeletedByAuthor', { count: deletedSentenceCount })}
      date={timestamp}
      serialNumber={serialNumber}
    />
  )
}

export default Deleted
